<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>

<div class="card text-center">
  <div class="card-header bg-primary text-left text-white font-weight-bold">
      SPRA Search
  </div>
  <div class="card-body mat-card">
      <div class="row">
          <div class="col-sm-6">
              <!-- <input type="text" id="txtFromDate" name="txtFromDate" [(ngModel)]="this.FromDate"
                          class="form-control"> -->
                          <div class="form-group row text-left">
                              <label for="lblFromDate" class="col-sm-4 col-form-label">From Date 
                                <span class="font-red-flamingo">*</span> </label>
                              <div class="col-sm-8">
                                <div class="input-group">
                                  <input class="form-control " (click)="d.toggle()"  placeholder="dd/mm/yyyy" name="txtFromDate" [(ngModel)]="this.FromDate"
                                    ngbDatepicker #d="ngbDatepicker">
                                  <div class="input-group-append">
                                    <button class="btn btn-light fa fa-calendar" (click)="d.toggle()" type="button"></button>
                                  </div>
                                </div>
                    
                    
                                <!-- <input type="text" id="txtContactPoDate" name="txtContactPoDate" class="form-control text-uppercase"> -->
                              </div>
                            </div>
             

          </div>
          <div class="col-sm-6">
              <div class="form-group row text-left">
                  <label for="lblToDate" class="col-sm-4 col-form-label">To Date
                      <span class="font-red-flamingo text-left">*</span>
                  </label>
                  <div class="col-sm-8">
                      <div class="input-group">
                          <input class="form-control" (click)="t.toggle()"  placeholder="dd/mm/yyyy" name="txtToDate" [(ngModel)]="this.ToDate"
                            ngbDatepicker #t="ngbDatepicker">
                          <div class="input-group-append">
                            <button class="btn btn-light fa fa-calendar" (click)="t.toggle()" type="button"></button>
                          </div>
                        </div>
                  </div>
              </div>

          </div>

      </div>
      <div class="row">

        <div class="col-sm-6">
          <div class="form-group row text-left">
              <label for="lblCustomerName" class="col-sm-4 col-form-label">Company Name</label>
              <div class="col-sm-8">
                  <input type="text" id="txtCustomerName" name="txtCustomerName" [(ngModel)]="this.customerName"
                      class="form-control">
              </div>
          </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group row text-left">
          <label for="lblSpraNumber" class="col-sm-4 col-form-label">SPRA Number</label>
          <div class="col-sm-8">
              <input type="text" id="txtSPRANumber" name="txtSPRANumber" [(ngModel)]="this.SpraNumber"
                  class="form-control">
          </div>
      </div>
       
    </div>
        
      </div>
      <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-6">
              <button type="button"  class="btn btn-primary" (click)="OnSubmit()">Submit</button>

          </div>
          <div class="col-sm-4"></div>    
      </div>
  </div>

</div>
<div class="card text-center" *ngIf="dataSource.data.length>0">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
     Spra Approved Rejected Review List
    </div>
    <div class="card-body mat-card">
      <div class="row">

        <div class="col-sm-12">
          <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control" (keyup)="doFilter($event)" placeholder="Filter">
          </div>
        </div>

        <div class="col-sm-12">
          <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc">

             <!-- Position Column -->
             <ng-container matColumnDef="requestNo">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Request No </mat-header-cell>
              <mat-cell *matCellDef="let element" class="btn-link text-primary" (click)="onRequestClick(element)"> {{element.requestNo}} </mat-cell>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="saleCode">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Sale Code </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.saleCode}} </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="partyName">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Company Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.partyName}} </mat-cell>
            </ng-container>

           

             <!-- Position Column -->
             <ng-container matColumnDef="productCategory">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Product Category </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.productCategory}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
             <ng-container matColumnDef="saleType">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Type </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.saleType}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
             <ng-container matColumnDef="lastValidatedBy">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Last ApprovedBy </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.lastValidatedBy}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="validatedate">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Validate Date </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                  {{element.validatedate}}                  
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="isRental">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Rental </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.isRental==true?'Yes':'No'}} </mat-cell>
                
              </ng-container>

              <ng-container matColumnDef="status">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Status </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
                
              </ng-container>
          
          
            <mat-header-row *matHeaderRowDef="ValidationListAdminsalesHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ValidationListAdminsalesHeader;"></mat-row>
          </mat-table>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-6 float-right text-right">
            <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>